import { useEffect, useState } from "react";
import { useStore } from "../../../models";
import { ImageUpload } from "./types";
import { getWheelhouseDownloadUrl } from "@fidget/common/utils/urlMappingHelpers";

export const useAgentAvatarSettings = () => {
  const { currentUserStore, uiStore } = useStore();
  const initialUrl = currentUserStore.orgConfig?.defaultAgentAvatarToken &&
    getWheelhouseDownloadUrl(currentUserStore.orgConfig?.defaultAgentAvatarToken);
  const initialAvatar = { file: undefined, url: initialUrl };

  const [isEdited, setIsEdited] = useState(false);
  const [avatar, setAvatar] = useState<ImageUpload>(initialAvatar);

  const reset = () => setAvatar(initialAvatar);

  useEffect(() => {
    setIsEdited(!!avatar.file || initialAvatar.url !== avatar.url);
  }, [avatar, initialAvatar]);

  const submit = async () => {
    const { orgConfig } = currentUserStore;
    if (!orgConfig) {
      return;
    }

    try {
      if (avatar?.file) {
        const url = await orgConfig.updateDefaultAgentAvatar(avatar.file);
        setAvatar({ file: undefined, url });
      } else {
        await orgConfig.deleteDefaultAgentAvatar();
        setAvatar({ file: undefined, url: undefined });
      }
    } catch (reason) {
      uiStore.addGenericErrorToast();
    }
  };

  return {
    avatarForm: { value: avatar, set: setAvatar },
    isAvatarFormEdited: isEdited,
    resetAvatarForm: reset,
    submitAvatarForm: submit
  };
};
